var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dealer-bike-loans"}},[_c('loans-table',{on:{"refreshList":_vm.refreshLoansList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }